import { useEffect } from 'react';
import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { AuthLayout } from '../components/layouts/AuthLayout';
import { MFA_SETUP_PATH } from '../lib/authGuard';
import { useLoginFlowStore } from '../stores/loginFlowStore';

export const Route = createFileRoute('/login')({
    beforeLoad: async ({ context, location }) => {
        // Solo aplicar el guard a /login exacto (no a children /login/new-password, etc.)
        // Los children tienen su propio search.session y NO deben redirigir si el user
        // ya está logueado — están en pleno flow de challenges del primer login.
        if (location.pathname !== '/login') return;
        const state = await context.auth.ensureLoaded();
        if (state.user) {
            if (state.user.mfaSetupRequired) throw redirect({ to: MFA_SETUP_PATH });
            throw redirect({ to: '/' });
        }
    },
    component: LoginLayout,
});

/**
 * Layout del área de login. Este componente solo se desmonta cuando el usuario abandona TODO el
 * subtree `/login/*` (navegar entre `/login`, `/login/mfa-challenge`, `/login/new-password` NO lo
 * desmonta — es el padre con `<Outlet/>`). Aprovechamos ese unmount para el 3er caso de limpieza
 * del spec §5 (DEC-019): si el usuario sale del área pre-auth SIN cancelar (tipea otra URL,
 * deep-link, back del navegador a una ruta no-login, etc.), limpiamos el store del flujo y el
 * cooldown de login (`reset()` borra ambos) para no dejar el `session` de Cognito colgado en
 * sessionStorage. El login exitoso y el "Cancelar" explícito ya llaman `reset()` desde los forms.
 */
export function LoginLayout() {
    useEffect(() => {
        return () => {
            useLoginFlowStore.getState().reset();
        };
    }, []);

    return (
        <AuthLayout>
            <Outlet />
        </AuthLayout>
    );
}
